export default window.__litium.constants;

export const ViewMode = {
  List: 'list',
  Edit: 'edit',
  Detail: 'detail',
};

export const PaginationOptions = {
  PageSize: 20, // Number of items per page
  DisplayedEntries: 4, // Specifies how many links to show excluding possible EdgeEntries
  EdgeEntries: 2, // Specifies how many links from beginning and end to show ex. 1 2 3 ... 10 20 30 ... 97 98 99 where "1 2 3" and "97 98 99" are edge entries
};

export const ShippingIntegrationType = {
  Inline: 'Inline',
    DeliveryCheckout: 'Inline',
  PaymentCheckout: 'PaymentCheckout',
};

export const PaymentIntegrationType = {
  IframeCheckout: 'IframeCheckout',
  PaymentWidgets: 'PaymentWidgets',
  DirectPayment: 'DirectPayment',
};

export const MegaMenuVisibility = {
  All: 'All',
  DesktopOnly: 'DesktopOnly',
  MobileOnly: 'MobileOnly',
};

export const GUID_EMPTY = '00000000-0000-0000-0000-000000000000';
export const ADDRESS_RECEIVE = 'ADDRESS_RECEIVE';
export const ADDRESS_ERROR = 'ADDRESS_ERROR';
export const ADDRESS_CHANGE_MODE = 'ADDRESS_CHANGE_MODE';

export const CART_LOAD_ERROR = 'CART_LOAD_ERROR';
export const CART_RECEIVE = 'CART_RECEIVE';
export const CART_SHOW_INFO = 'CART_SHOW_INFO';

export const CHECKOUT_SET_SELECTED_COMPANY_ADDRESS =
  'CHECKOUT_SET_SELECTED_COMPANY_ADDRESS';
export const CHECKOUT_SET_PRIVATE_CUSTOMER = 'CHECKOUT_SET_PRIVATE_CUSTOMER';
export const CHECKOUT_SET_SIGN_UP = 'CHECKOUT_SET_SIGN_UP';
export const CHECKOUT_SET_DELIVERY = 'CHECKOUT_SET_DELIVERY';
export const CHECKOUT_SET_COUNTRY = 'CHECKOUT_SET_COUNTRY';
export const CHECKOUT_SET_PAYMENT = 'CHECKOUT_SET_PAYMENT';
export const CHECKOUT_SET_DISCOUNT_CODE = 'CHECKOUT_SET_DISCOUNT_CODE';
export const CHECKOUT_SET_USED_DISCOUNT_CODE =
  'CHECKOUT_SET_UASED_DISCOUNT_CODE';
export const CHECKOUT_SET_CUSTOMER_REFERENCE =
  'CHECKOUT_SET_CUSTOMER_REFERENCE';
export const CHECKOUT_SET_ORDER_NOTE = 'CHECKOUT_SET_ORDER_NOTE';
export const CHECKOUT_ACCEPT_TERMS_OF_CONDITION = 'CHECKOUT_ACCEPT_TERMS_OF_CONDITION';
export const CHECKOUT_SET_PARTIAL_DELIVERY = 'CHECKOUT_SET_PARTIAL_DELIVERY';
export const CHECKOUT_SUBMIT = 'CHECKOUT_SUBMIT';
export const CHECKOUT_SUBMIT_ERROR = 'CHECKOUT_SUBMIT_ERROR';
export const CHECKOUT_SET_PAYMENT_WIDGET = 'CHECKOUT_SET_PAYMENT_WIDGET';
export const CHECKOUT_SET_SHIPMENT_WIDGET = 'CHECKOUT_SET_SHIPMENT_WIDGET';
export const CHECKOUT_UPDATE_CUSTOMER_INFO = 'CHECKOUT_UPDATE_CUSTOMER_INFO';
export const CHECKOUT_SET_SHOW_ALTERNATIVE_ADDRESS =
  'CHECKOUT_SET_SHOW_ALTERNATIVE_ADDRESS';
export const CHECKOUT_SET_STATUS_SUBMIT_BUTTON =
  'CHECKOUT_SET_STATUS_SUBMIT_BUTTON';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const CHECKOUT_VALIDATE_ADDRESS = 'CHECKOUT_VALIDATE_ADDRESS';

export const FACETED_SEARCH_QUERY = 'FACETED_SEARCH_QUERY';
export const FACETED_SEARCH_RECEIVE = 'FACETED_SEARCH_RECEIVE';
export const FACETED_SEARCH_ERROR = 'FACETED_SEARCH_ERROR';
export const FACETED_SEARCH_TOGGLE_VALUE = 'FACETED_SEARCH_TOGGLE_VALUE';
export const FACETED_SEARCH_TOGGLE_COMPACT = 'FACETED_SEARCH_TOGGLE_COMPACT';
export const PRODUCT_VIEW_CACHED = 'PRODUCT_VIEW_CACHED';

export const LIGHTBOX_IMAGES_SET_CURRENT_IMAGE =
  'LIGHTBOX_IMAGES_SET_CURRENT_IMAGE';
export const LIGHTBOX_IMAGES_SHOW = 'LIGHTBOX_IMAGES_SHOW';

export const NAVIGATION_LOAD_ERROR = 'NAVIGATION_LOAD_ERROR';
export const NAVIGATION_RECEIVE = 'NAVIGATION_RECEIVE';

export const PERSON_RECEIVE = 'PERSON_RECEIVE';
export const PERSON_ERROR = 'PERSON_ERROR';
export const PERSON_CHANGE_MODE = 'PERSON_CHANGE_MODE';

export const DEALER_INFO_RECEIVE = 'DEALER_INFO_RECEIVE';
export const DEALER_INFO_ERROR = 'DEALER_INFO_ERROR';
export const DEALER_INFO_CHANGE_MODE = 'DEALER_INFO_CHANGE_MODE';

export const FIND_MY_PART_RECEIVE = 'FIND_MY_PART_RECEIVE';
export const FIND_MY_PART_RECEIVE_OPTIONS = 'FIND_MY_PART_RECEIVE_OPTIONS';
export const FIND_MY_PART_RECEIVE_SEGMENTS = 'FIND_MY_PART_RECEIVE_SEGMENTS';
export const FIND_MY_PART_ERROR = 'FIND_MY_PART_ERROR';
export const FIND_MY_PART_CHANGE_MODE = 'FIND_MY_PART_CHANGE_MODE';
export const FIND_MY_PART_RECEIVE_SEARCH_ITEMS =
  'FIND_MY_PART_RECEIVE_SEARCH_ITEMS';

export const PRODUCT_CONFIGURATOR_RECEIVE = 'PRODUCT_CONFIGURATOR_RECEIVE';
export const PRODUCT_CONFIGURATOR_SEND = 'PRODUCT_CONFIGURATOR_SEND';
export const PRODUCT_CONFIGURATOR_UPDATE = 'PRODUCT_CONFIGURATOR_UPDATE';
export const PRODUCT_CONFIGURATOR_BUTTON_STATUS =
  'PRODUCT_CONFIGURATOR_BUTTON_STATUS';

export const QUICK_SEARCH_QUERY = 'QUICK_SEARCH_QUERY';
export const QUICK_SEARCH_RECEIVE = 'QUICK_SEARCH_RECEIVE';
export const QUICK_SEARCH_ERROR = 'QUICK_SEARCH_ERROR';
export const QUICK_SEARCH_SHOW_FULL_FORM = 'QUICK_SEARCH_SHOW_FULL_FORM';
export const QUICK_SEARCH_SELECT_ITEM = 'QUICK_SEARCH_SELECT_ITEM';

export const QUICK_ORDER_RECEIVE_PARSE_ITEMS =
  'QUICK_ORDER_RECEIVE_PARSE_ITEMS';
export const QUICK_ORDER_CREATE_ITEM = 'QUICK_ORDER_CREATE_ITEM';
export const QUICK_ORDER_UPDATE_ITEM = 'QUICK_ORDER_UPDATE_ITEM';
export const QUICK_ORDER_DELETE_ITEM = 'QUICK_ORDER_DELETE_ITEM';
export const QUICK_ORDER_DELETE_ITEMS = 'QUICK_ORDER_DELETE_ITEMS';
export const QUICK_ORDER_RECEIVE_ERROR_ITEM = 'QUICK_ORDER_RECEIVE_ERROR_ITEM';
export const QUICK_ORDER_RECEIVE_ERROR = 'QUICK_ORDER_RECEIVE_ERROR';

export const ORDER_RECEIVE = 'ORDER_RECEIVE';
export const ORDER_ERROR = 'ORDER_ERROR';
export const ORDER_CHANGE_MODE = 'ORDER_CHANGE_MODE';
export const ORDER_CHANGE_CURRENTPAGE = 'ORDER_CHANGE_CURRENTPAGE';
export const ORDER_SET_ORDER = 'ORDER_SET_ORDER';

export const LANGUAGE_SELECTOR_SHOW_WINDOW = 'LANGUAGE_SELECTOR_SHOW_WINDOW';
export const LANGUAGE_SELECTOR_RECEIVE = 'LANGUAGE_SELECTOR_RECEIVE';

export const LIBRARY_RECEIVE = 'LIBRARY_RECEIVE';
export const LIBRARY_CATEGORIES = 'LIBRARY_CATEGORIES';
export const LIBRARY_DOCUMENT_TYPES = 'LIBRARY_DOCUMENT_TYPES';
export const LIBRARY_RECEIVE_CATEGORIES = 'LIBRARY_RECEIVE_CATEGORIES';
export const LIBRARY_RECEIVE_DOCUMENT_TYPES = 'LIBRARY_RECEIVE_DOCUMENT_TYPES';
export const LIBRARY_FILTER = 'LIBRARY_FILTER';
export const LIBRARY_SELECTED = 'LIBRARY_SELECTED';

export const COMPARE_PRODUCT_LOADED = 'COMPARE_PRODUCT_LOADED';
export const COMPARE_PRODUCT_URL_UPDATED = 'COMPARE_PRODUCT_URL_UPDATED';

export const COMPARE_PRODUCT_REMOVED = 'COMPARE_PRODUCT_REMOVED';
export const PRODUCT_COMPARISON_LOAD_ERROR = 'PRODUCT_COMPARISON_LOAD_ERROR';

export const SPRING_CALC_LOAD_ERROR = 'SPRING_CALC_LOAD_ERROR';
export const SPRING_CALC_RECEIVE = 'SPRING_CALC_RECEIVE';
export const SPRING_CALC_SHOW_INFO = 'SPRING_CALC_SHOW_INFO';
export const SPRING_CALC_ADDING_MANY = 'SPRING_CALC_ADDING_MANY';
export const SPRING_CALC_TOGGLE_SHOW = 'SPRING_CALC_TOGGLE_SHOW';
export const SPRING_CALC_RECEIVE_CALCULATED_VALUES =
  'SPRING_CALC_RECEIVE_CALCULATED_VALUES';
export const SPRING_CALC_TOGGLE_BUTTON_STATUS =
  'SPRING_CALC_TOGGLE_BUTTON_STATUS';

export const ACCOUNT_ORDERS_RECEIVE = 'ACCOUNT_ORDERS_RECEIVE';
export const ACCOUNT_ORDERS_ERROR = 'ACCOUNT_ORDERS_ERROR';
export const ACCOUNT_ORDERS_LOADING = 'ACCOUNT_ORDERS_LOADING';
export const ACCOUNT_ORDERS_RESET = 'ACCOUNT_ORDERS_RESET';
export const ACCOUNT_ORDERS_SET_ORDER = 'ACCOUNT_ORDERS_SET_ORDER';
export const ACCOUNT_ORDERS_CHANGE_MODE = 'ACCOUNT_ORDERS_CHANGE_MODE';
export const ACCOUNT_ORDERS_RECEIVE_LINES = 'ACCOUNT_ORDERS_RECEIVE_LINES';
export const ACCOUNT_ORDERS_LINES_LOADING = 'ACCOUNT_ORDERS_LINES_LOADING';
